import React, { useEffect } from 'react';
import { Outlet } from '@tanstack/react-router';
import { useHouseContext } from '@/context/HouseContext';

/**
 * Layout route for property-scoped pages.
 * Syncs the URL param (public_id) to HouseContext so all child routes
 * operate on the correct house without relying on localStorage for selection.
 */
const PropertyLayout: React.FC = () => {
	const { propertyPublicId } = Route.useParams();
	const { houses, setSelectedHouseId } = useHouseContext();

	useEffect(() => {
		if (!propertyPublicId || houses.length === 0) return;
		const match = houses.find((h) => h.public_id === propertyPublicId);
		if (match) {
			setSelectedHouseId(match.id);
		}
	}, [propertyPublicId, houses, setSelectedHouseId]);

	return <Outlet />;
};

export const Route = createFileRoute({
	component: PropertyLayout,
});
